import { cn } from 'lib/utils'
import type { ReactNode } from 'react'

export const PRICING_DATA_THEME = 'dark' as const

function pricingSurfaceClass(className?: string) {
  return cn('taka-dark', className)
}

/**
 * Dialog props for the IN-APP paywall + top-up modals.
 *
 * `variant: 'dark'` is the T3 *dual-theme* DialogContent recipe — its classes
 * (`bg-bg-2`, `border-line`, `text-paper`, `ring-acid`…) are tokens that flip
 * with `data-theme`. We deliberately do NOT pin `data-theme` here, so these
 * in-app modals follow the user's chosen theme (light or dark).
 *
 * The brand-pinned entry points — login, onboarding shell, and the onboarding
 * paywall — keep their dark pin separately via `PRICING_DATA_THEME` /
 * `PricingThemeSurface`.
 */
export function pricingDialogProps(className?: string) {
  return {
    variant: 'dark' as const,
    className: pricingSurfaceClass(className),
  }
}

/**
 * Dark-pinned surface for the brand entry points (onboarding paywall). Unlike
 * `pricingDialogProps`, this keeps `data-theme="dark"` so the surface stays
 * dark regardless of the user's chosen app theme.
 */
export function PricingThemeSurface({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div data-theme={PRICING_DATA_THEME} className={pricingSurfaceClass(className)}>
      {children}
    </div>
  )
}
